import { ErrorsType } from '@src/types/errors';
import { handleCookie, handleLocalStorage } from '@utils';

import { LoadersType } from '@modules/builders';
import { ProtectNextEnum } from '@modules/types';

import { asyncActions } from './actions';

const { getItem } = handleLocalStorage;

export type LoginStateType = {
  loaders: LoadersType<typeof asyncActions>;
  errors: ErrorsType;
  idleTimeout: number;
  status?: number;
  token?: string;
  verification: {
    phone?: string;
    email?: string;
    key?: string;
    token?: string;
    code_length?: number;
    timeout?: number;
    editToken?: string;
  };
  protectNext?: ProtectNextEnum;
  isLoggedIn: boolean;
};

const verification = getItem('verification') || {};

const idleTimeout = Number(handleCookie.getCookie('idleTimeout')) || 900;

const initialState: LoginStateType = {
  loaders: {},
  errors: {},
  verification,
  idleTimeout,
  isLoggedIn: false,
};

export default initialState;
